import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Nav from "../components/nav/Nav";
import Container from "../components/Container";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import RequiredForm from "../components/form/RequiredForm";
import cr from "../lib/request";
import PasswordInput from "../components/form/PasswordInput";

export default function ResetPasswordInput() {
  const { resetpasswordticket } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [loading, setLoading] = useState<boolean>(false);

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      password: "",
      confirmPassword: "",
    },

    validationSchema: yup.object().shape({
      password: yup.string().required("Email harus diisi"),
    }),

    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const url = `api/usercourse/resetpassword`;
      const payload = {
        ticket: resetpasswordticket,
        password: values.password,
        confirmPassword: values.confirmPassword,
      };
      cr.post(url, payload)
        .then((r) => {
          if (r.status === 200) {
            toast({
              title: r.data?.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            navigate("/");
          }
        })
        .catch((e) => {
          console.log(e);
          toast({
            title: e?.response?.data?.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <VStack gap={0} minH={"100vh"}>
      <Nav />
      <Container>
        <VStack p={5} w={"100%"} maxW={"500px"} align={"stretch"} mx={"auto"}>
          <Text fontWeight={600} fontSize={24} mb={2}>
            Reset Password
          </Text>

          <Alert
            minW={"100% !important"}
            status="warning"
            variant={"left-accent"}
            mb={4}
            alignItems={"flex-start"}
          >
            <AlertIcon />
            <AlertDescription mt={0} lineHeight={"1.4 !important"}>
              Masukkan password baru anda
            </AlertDescription>
          </Alert>

          <form id="resetPasswordCekEmailForm" onSubmit={formik.handleSubmit}>
            <FormControl
              mb={4}
              isInvalid={formik.errors.password ? true : false}
            >
              <FormLabel>
                Password Baru
                <RequiredForm />
              </FormLabel>
              <PasswordInput
                name="password"
                placeholder="Masukkan password baru"
                formik={formik}
              />
              <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
            </FormControl>

            <FormControl
              mb={4}
              isInvalid={formik.errors.confirmPassword ? true : false}
            >
              <FormLabel>
                Konfirmasi Password Baru
                <RequiredForm />
              </FormLabel>
              <PasswordInput
                name="confirmPassword"
                placeholder="Konfirmasi password baru"
                formik={formik}
              />
              <FormErrorMessage>
                {formik.errors.confirmPassword}
              </FormErrorMessage>
            </FormControl>
          </form>

          <Button
            type="submit"
            form="resetPasswordCekEmailForm"
            colorScheme="ap"
            className="clicky"
            isLoading={loading}
          >
            Reset Password
          </Button>
        </VStack>
      </Container>
    </VStack>
  );
}
